if (process.env.BROWSER) {
  module.exports = window.App.config;
} else {
  module.exports = {
    api: {
      licenseUrl: process.env.LICENSE_URL,
      mediaUrl: process.env.MEDIA_URL,
      region: process.env.API_REGION,
      uploadBucket: process.env.USER_UPLOAD_BUCKET,
    },

    search: {
      endpoint: process.env.SEARCH_URL,
      staticAssetRemapping: process.env.STATIC_ASSET_PATH_REMAPPING,
    },

    cognito: {
      userPool: process.env.COGNITO_USER_POOL_ID,
      identityPool: process.env.COGNITO_IDENTITY_POOL_ID,
      clientId: process.env.COGNITO_APP_CLIENT_ID,
      region: process.env.COGNITO_REGION,
    },

    stripe: {
      pk: process.env.STRIPE_PK,
    },

    // Web analytics
    analytics: {
      // https://analytics.google.com/
      googleTrackingId: process.env.GOOGLE_TRACKING_ID, // UA-XXXXX-X

      // https://rollbar.com
      rollbarAccessToken: process.env.ROLLBAR_CLIENT_ACCESS_TOKEN,

      // https://www.hotjar.com
      hjid: process.env.HOTJAR_ID,

      proofAccId: process.env.PROOF_ACC_ID,

      facebookPixelId: process.env.FACEBOOK_PIXEL_ID,
    },

    url: {
      supportEmailAddress: process.env.SUPPORT_EMAIL_ADDRESS,
    },
  };
}



// WEBPACK FOOTER //
// ./src/config.js